<template>
  <section class="block">
    <div class="container container--max-desktop">
      <div class="page-content text-center">
        <h2>There were no results</h2>
        <p>Sorry, no results were found using the selected filters.</p>
        <hr />
      </div>
    </div>
  </section>
</template>
